<template>
  <div
    class="calico-card-info"
    :class="variant"
  >
    <div class="label label--xsmall">
      {{ label }}
    </div>

    <div class="content body--small">
      {{ content }}
    </div>
  </div>
</template>

<script>
export default {
  name: "CalicoCardInfo",
  props: {
    label: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      default: "default",
    },
  },
};
</script>

<style lang="scss" scoped>
.calico-card-info {
  border-radius: $radius-medium;
  @include inset-space($space-medium);
  @include stack-space($space-xsmall);
  gap: $space-xsmall;

  &.default {
    background-color: $color-neutral-lightest;
  }

  &.muted {
    background-color: $color-neutral;
    border: $border-width-default solid $color-neutral-dark;
  }

  &.dark {
    background-color: $color-neutral-darkest;
    color: $color-text-primary-alt;

    .content {
      @extend .body--small;
    }
  }

  &.light {
    background-color: $color-white;

    .content {
      @extend .body--large;
    }
  }
}
</style>